module.exports = __webpack_public_path__ + "static/media/taking-note.8b8da672.svg";